import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

/** Shows an "Install app" button when the browser offers PWA installation. */
export const InstallPrompt = () => {
  const [evt, setEvt] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setEvt(null));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!evt) return null;
  return (
    <Button size="sm" variant="outline" data-testid="install-app-button"
      className="rounded-full h-9 px-3 text-xs"
      onClick={async () => { evt.prompt(); await evt.userChoice; setEvt(null); }}>
      <Download className="h-3.5 w-3.5 mr-1.5" aria-hidden="true" />
      <span className="hidden sm:inline">Install app</span>
      <span className="sm:hidden">Install</span>
    </Button>
  );
};
